export type PlanKey = '1month' | '3month' | '12month';

export const PLAN_MONTHS: Record<PlanKey, number> = {
  '1month': 1,
  '3month': 3,
  '12month': 12,
};

export const PLAN_LABELS: Record<PlanKey, string> = {
  '1month': '1개월',
  '3month': '3개월',
  '12month': '1년',
};

export const PLANS: Record<'member' | 'owner', Record<PlanKey, number>> = {
  member: { '1month': 9900, '3month': 19900, '12month': 49900 },
  owner: { '1month': 99000, '3month': 199000, '12month': 499000 },
};

export const BANK_INFO = {
  bank: 'KB국민',
  account: '839802-01-565535',
  holder: '황명철',
};

export const CAPACITY_EXPANSION_PRICE = 99000;
export const CAPACITY_EXPANSION_SLOTS = 100;

export const TRANSFER_NOTICE =
  '가입 시 입력한 이름(실명)과 계좌이체 시 입금자명이 반드시 일치해야 합니다. 일치하지 않을 경우 입금 확인이 어려워 승인이 지연되거나 거절될 수 있습니다.';

export const APPROVAL_NOTICE = '가입 승인은 24시간 이내에 처리됩니다.';

export const REFUND_POLICIES: string[] = [
  '본 이용권은 디지털 콘텐츠(온라인 서비스)로, 전자상거래 등에서의 소비자보호에 관한 법률 및 소비자분쟁해결기준에 따라 환불이 처리됩니다.',
  '1개월 이용권은 결제 즉시 환불이 불가합니다.',
  '3개월·1년 이용권은 환불 신청 시 1개월 이용금액을 공제하고 나머지 금액만 환불됩니다.',
  '환불 신청은 운영자에게 접수되며, 운영자가 확인 후 개인 송금으로 환불해드립니다.',
  '입금 후 운영자 승인(활성화) 전에는 전액 환불됩니다.',
];

export function calcRefundAmount(role: 'member' | 'owner', plan: PlanKey): number {
  if (plan === '1month') return 0;
  const paid = PLANS[role][plan];
  const oneMonth = PLANS[role]['1month'];
  return Math.max(paid - oneMonth, 0);
}

export function formatPrice(price: number): string {
  return price.toLocaleString('ko-KR');
}

export function isSubscriptionExpired(expiresAt: string | null | undefined): boolean {
  if (!expiresAt) return false;
  return new Date(expiresAt).getTime() < Date.now();
}

export function formatExpiry(expiresAt: string | null | undefined): string {
  if (!expiresAt) return '-';
  return new Date(expiresAt).toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function calcRemainingMonths(expiresAt: string): number {
  const now = new Date();
  const exp = new Date(expiresAt);
  const diffTime = exp.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.max(0, Math.round(diffDays / 30));
}